<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">
			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">{{ $t('moderations.title') }}</h4>
				</div>
			</div>

			<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
				<span class="visually-hidden">{{ $t('common.loading') }}</span>
			</div>

			<div class="col-lg-12" v-if="!isLoading">

				<div class="card h-100">
					<div class="table-responsive">
						<table class="table table-borderless">
							<thead>
								<tr class="border-bottom">
									<th class="bg-transparent fs-xsmall">{{ $t('moderations.employee') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('moderations.training') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('moderations.price') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('common.fields.status') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('moderations.requestedAt') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('common.fields.actions') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(training, index) in trainings" :key="index">
									<div class="d-flex justify-content-start align-items-center">
										<div>
											<h6 class="mb-0 text-truncate">{{ training.user.firstName }} {{ training.user.lastName }} ({{ training.company.name }})</h6>
											<span>
												{{ training.user.email }}
											</span>
										</div>
									</div>
									<td>
										{{ training.formationName }}
									</td>
									<td>
										{{ training.billingMethod === 'invoices' ? training.price + ' €' : training.price + ' crédits' }}
									</td>
									<td>
										<span class="badge bg-label-warning rounded-pill">{{ $t('moderations.pendingValidation') }}</span>
									</td>
									<td>
										{{ formatDate(training.createdAt) }}
									</td>
									<td>
										<a class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="updateRequest(training._id, 'accept')">
											<i class="ri-check-line ri-22px"></i>
										</a>
										<a class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="updateRequest(training._id, 'refuse')">
											<i class="ri-close-line ri-22px"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

moment.locale(localStorage.getItem('locale') || 'fr');

export default {
	name: "ModerationsPage",

	data() {
		return {
			isLoading: true,
			trainings: [],
		};
	},

	methods: {
		async fetchModerationRequests() {
			try {
				const response = await HTTP('/moderations');
				this.trainings = response.data.trainings;

				console.log(response.data)
				this.isLoading = false;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		formatDate(date) {
			return moment(date).format("DD/MM/YYYY"); // Affiche "il y a 3 semaines"
		},

		formatRelativeDate(date) {
			return moment(date).fromNow(); // Affiche "il y a 3 semaines"
		},

		async updateRequest(trainingId, action) {
			try {
				const response = await HTTP.put('/moderations/update-request', { trainingId, action });
				
				console.log(response.data);
				this.fetchModerationRequests();
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},
	},

	async mounted() {
		this.fetchModerationRequests();
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.load-center {
	display: block;
	margin: 0 auto;
}
</style>
